<ng-container *transloco="let t">
  <div
    id="forgot-password-success-card"
    class="bg-white rounded-2xl max-sm:rounded-b-none shadow-card max-sm:shadow-none w-full max-w-[480px] max-sm:max-w-full min-w-0 p-4 sm:p-10 max-xs:px-3"
  >
    <div id="forgot-password-success-header" class="flex flex-col items-center gap-2 mb-4">
      <img id="forgot-password-success-logo" [src]="logoUrl()" [alt]="partnerDisplayName()" class="h-14 w-auto" />
      <h1 id="forgot-password-success-title" class="text-section-heading text-ld-neutral-700 m-0">
        {{ t('authForgotPasswordSuccessTitle') }}
      </h1>
    </div>

    <p id="forgot-password-success-subtitle" class="font-dm text-sm leading-5 text-ld-neutral-500 text-center m-0 mb-6">
      {{ t('authForgotPasswordSuccessSubtitle') }}
    </p>

    <div id="forgot-password-success-help" class="mb-6 text-left">
      <p
        id="forgot-password-success-list-title"
        class="font-dm font-semibold text-sm leading-5 text-ld-neutral-700 m-0 mb-3"
      >
        {{ t('authForgotPasswordSuccessListTitle') }}
      </p>
      <ol
        id="forgot-password-success-list"
        class="font-dm text-sm leading-5 text-ld-neutral-500 m-0 pl-5 flex flex-col gap-2"
      >
        <li>{{ t('authForgotPasswordSuccessItem1') }}</li>
        <li>
          <button
            type="button"
            id="forgot-password-success-try-again-link"
            (click)="onTryAgain()"
            class="bg-transparent border-0 text-ld-link cursor-pointer p-0 font-dm text-sm leading-5 hover:underline focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded inline text-left"
          >
            {{ t('authForgotPasswordSuccessItem2') }}
          </button>
        </li>
        <li>{{ t('authForgotPasswordSuccessItem3') }}</li>
      </ol>
    </div>

    <div id="forgot-password-success-back-link" class="flex items-center justify-center">
      <button
        type="button"
        id="forgot-password-success-back-button"
        (click)="onBackToLogin()"
        class="bg-transparent border-0 text-ld-link cursor-pointer p-0 font-dm text-sm font-medium leading-4 hover:underline focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 focus-visible:rounded touch-target"
      >
        {{ t('commonLabelsBackToSignIn') }}
      </button>
    </div>
  </div>
</ng-container>
